import { UAParser } from 'ua-parser-js';

export const isIosSafari = () => {
  const res = UAParser();

  const isSafari = res.browser.name?.toLowerCase().includes('safari');
  const isIpad = res.device.type?.toLowerCase() === 'tablet';
  const isIphone = res.device.type?.toLowerCase() === 'mobile';

  return Boolean(isSafari && (isIpad || isIphone));
};
